import React, { Component } from 'react';

import classes from './OrderSummary.module.css';

import Auxilliary from '../../../hoc/Auxilliary/Auxilliary';
import Button from '../../UI/Button/Button';

class OrderSummary extends Component {
	componentDidUpdate(prevProps, prevState) {
		// console.log('Order Summary[Component Did Update]');
	}

	render() {
		let ingredientSummary = null;
		if (this.props.ingredients) {
			ingredientSummary = Object.keys(this.props.ingredients).map((key) => {
				return (
					<li key={key}>
						<span style={{ textTransform: 'capitalize' }}>{key}</span>:{' '}
						{this.props.ingredients[key]}
					</li>
				);
			});
		}
		return (
			<Auxilliary>
				<h3 className={classes.Heading}>Your Order</h3>
				<p>Delicious Burger with following ingredients:</p>
				<ul className={classes.IngredientList}>{ingredientSummary}</ul>
				<p className={classes.Price}>
					<strong>Total Price: ₹ {this.props.price.toFixed(2)}</strong>
				</p>
				<p>Do you want to checkout?</p>
				<Button clicked={this.props.cancelOrder} buttonType="Danger">
					Cancel
				</Button>
				<Button clicked={this.props.continueOrder} buttonType="Success">
					Continue
				</Button>
			</Auxilliary>
		);
	}
}

export default OrderSummary;
